// extracted by mini-css-extract-plugin
export default {"container":"Section_container__P1AjE","content":"Section_content__VA6tL","content--page":"Section_content--page__EWHXl","content--form":"Section_content--form__IeefF"};